module.exports = __webpack_public_path__ + "img/level_2-1.ec5619a0.svg";